export default __webpack_public_path__ + "static/media/assetTradeIcon6.abb300ca.webp";